import { useState } from "react";
import { Plus } from "lucide-react";
import { faqHeading, faqItems } from "@/lib/faqData";
import Reveal from "@/components/public/Reveal";

export default function FaqAccordion({ lang }) {
  const [open, setOpen] = useState(0);
  const h = faqHeading(lang);
  const items = faqItems(lang);

  return (
    <section id="faq" className="container-x py-20 md:py-28" data-testid="faq-section">
      <div className="text-center mb-12">
        <span className="inline-block text-xs uppercase tracking-widest px-4 py-1.5 rounded-full bg-surface border border-white/10 text-subtle">{h.pill}</span>
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mt-5 bg-gradient-to-r from-ink via-ink to-copper bg-clip-text text-transparent">
          {h.title}
        </h2>
        <p className="text-subtle text-base md:text-lg mt-4">{h.sub}</p>
      </div>

      <div className="max-w-4xl mx-auto space-y-4">
        {items.map((f, i) => {
          const isOpen = open === i;
          return (
            <Reveal key={i} delay={(i % 4) * 60}>
              <div className={`rounded-2xl border transition-colors duration-300 ${isOpen ? "border-copper/50 bg-surface" : "border-white/10 bg-graphite/60"}`}>
                <button
                  data-testid={`faq-trigger-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                  aria-expanded={isOpen}
                >
                  <span className="text-base sm:text-lg font-semibold text-ink">{f.q}</span>
                  <span className={`shrink-0 w-9 h-9 rounded-full bg-copper text-white flex items-center justify-center transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`}>
                    <Plus size={18} />
                  </span>
                </button>
                <div
                  className="grid transition-all duration-300 ease-out"
                  style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                >
                  <div className="overflow-hidden">
                    <p data-testid={`faq-answer-${i}`} className="px-6 pb-6 text-subtle text-sm sm:text-base leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
